/**
 * Сортировка ленты отзывов. Значение селекта — строка «поле:направление»,
 * в запрос уходят `SortField` (`new` | `rating`) и `SortDirection` (`asc` | `desc`).
 * Модели `@repo/api` здесь не импортируются — файл тестируется в `bun test`.
 */

export type ReviewsSortField = 'new' | 'rating'

export type ReviewsSort = { field: ReviewsSortField, desc: boolean }

export const DEFAULT_REVIEWS_SORT = 'new:desc'

/** Размер страницы ленты; с ним и сортировкой по умолчанию страница товара грузит первую страницу для ленты */
export const REVIEWS_FEED_LIMIT = 10

export const REVIEWS_SORT_OPTIONS = [
  { label: 'Сначала новые', value: 'new:desc' },
  { label: 'Сначала хорошие', value: 'rating:desc' },
  { label: 'Сначала плохие', value: 'rating:asc' },
] as const

const knownValues = new Set<string>(REVIEWS_SORT_OPTIONS.map(o => o.value))

/** «rating:asc» → `{ field: 'rating', desc: false }`; неизвестное значение — сортировка по умолчанию. */
export function parseReviewsSort(value: string): ReviewsSort {
  const [field, direction] = (knownValues.has(value) ? value : DEFAULT_REVIEWS_SORT).split(':')
  return { field: field as ReviewsSortField, desc: direction === 'desc' }
}

/** Обратное преобразование из полей запроса; неизвестная комбинация — сортировка по умолчанию. */
export function reviewsSortValue(field: unknown, direction: unknown): string {
  const value = `${String(field)}:${String(direction)}`
  return knownValues.has(value) ? value : DEFAULT_REVIEWS_SORT
}
